import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FinanceReportsReducer } from '../reducers';

export const selectFinanceReportsFeature = createFeatureSelector<FinanceReportsReducer.FinanceReportsState>(FinanceReportsReducer.featureName);

export const selectFinanceReports = createSelector(selectFinanceReportsFeature, (state: FinanceReportsReducer.FinanceReportsState) => state.item);
